module.exports = __webpack_public_path__ + "img/radio-on.927d053a.svg";